module.exports = __webpack_public_path__ + "static/brand2-f8df25a145263dec712b3487d729f465.png";